import { useState } from 'react';

export default function QuestionFlow({ questions, onComplete }) {
  const [index, setIndex] = useState(0);
  const [selected, setSelected] = useState(null);
  const [answers, setAnswers] = useState({ lifestyle: [], dosha: [], intimacy: [] });
  const [key, setKey] = useState(0);

  const total = questions.length;
  const current = questions[index];
  const progress = ((index) / total) * 100;

  const handleSelect = (value) => {
    if (selected !== null) return;
    setSelected(value);

    const entry = { questionId: current.backendId, answer: value };
    const type = current.type;
    setAnswers(prev => ({
      ...prev,
      [type]: [...prev[type].filter(a => a.questionId !== current.backendId), entry],
    }));

    setTimeout(() => {
      if (index < total - 1) {
        setIndex(i => i + 1);
        setSelected(null);
        setKey(k => k + 1);
      } else {
        onComplete({
          lifestyle: [...answers.lifestyle.filter(a => a.questionId !== current.backendId),
            ...(type === 'lifestyle' ? [entry] : [])],
          dosha: [...answers.dosha.filter(a => a.questionId !== current.backendId),
            ...(type === 'dosha' ? [entry] : [])],
          intimacy: [...answers.intimacy.filter(a => a.questionId !== current.backendId),
            ...(type === 'intimacy' ? [entry] : [])],
        });
      }
    }, 340);
  };

  return (
    <div className="q-screen">
      <div className="progress-bar">
        <div className="progress-bar-fill" style={{ width: `${progress}%` }} />
      </div>

      <div key={key} className="fade-up" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <div className="q-section-label">{current.section}</div>

        <div className="q-question">{current.question}</div>

        {current.note && (
          <div className="q-note">{current.note}</div>
        )}
        {!current.note && <div style={{ height: 28 }} />}

        <div className="q-options">
          {current.options.map((opt) => (
            <button
              key={opt.value}
              className={`option-card${selected === opt.value ? ' selected' : ''}`}
              onClick={() => handleSelect(opt.value)}
              disabled={selected !== null}
            >
              {opt.text}
            </button>
          ))}
        </div>

        <div style={{ marginTop: 'auto', paddingTop: 24, color: 'var(--very-muted)', fontSize: 11, letterSpacing: 1.5, textAlign: 'center' }}>
          {index + 1} / {total}
        </div>
      </div>
    </div>
  );
}
